  document.addEventListener("DOMContentLoaded", function(event) { 
  // Function to pass referrals tracking info to checkouts
  var params = window.location.search;

  var checkoutLinks = document.querySelectorAll(`[href*="https://app.strengthbymari.com"]`);
  
  checkoutLinks.forEach(function(element) {
    element.href = `${element.href}${params}`;
  })
});
